module.exports = __webpack_public_path__ + "img/cg.e0101aac.svg";